const getFacilityZip = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Address'] && facility['Company Address']['Zip Code']) {
    return facility['Company Address']['Zip Code'];
  }
  return null;
};

export default getFacilityZip;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityZip.js